module.exports = __webpack_public_path__ + "img/earth_secure_full.376fb6a2.png";